import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { getAssignedCandidates } from '../../../services/admin/api';
import { FilePlus2, Eye } from 'lucide-react';
import './AssignedCandidates.css';

const AssignedCandidates = () => {
  const { employeeId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const employeeName = location.state?.employeeName || 'Unknown';
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        setLoading(true);
        const data = await getAssignedCandidates(employeeId);
        //console.log("Fetched Candidates: ", data);
        setCandidates(data || []);
      } catch (err) {
        setError('Failed to load assigned candidates.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (employeeId) {
      fetchCandidates();
    }
  }, [employeeId]);

 return (
  <div className="assigned-candidates-container">
    <div className="assigned-card-wrapper">
      <div className="assigned-header">
        <h2>
          Assigned Candidates for <span>{employeeName}</span>
        </h2>
        <button onClick={() => navigate(-1)} className="back-button">← Back</button>
      </div>

      {loading ? (
        <p>Loading assigned candidates...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : candidates.length === 0 ? (
        <p>No candidates assigned to this employee.</p>
      ) : (
        <div className="assigned-candidates-card">
          <div className="table-container">
            <table className="assigned-candidates-table">
              <thead>
                <tr>
                  <th>Candidate ID</th>
                  <th>Candidate Name</th>
                  <th>Client Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Assigned At</th>
                  <th>Current BGC Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {candidates.map((cand) => (
                  <tr key={cand.id}>
                    <td>{cand.candidateId}</td>
                    <td>{cand.fullName}</td>
                    <td>{cand.clientName}</td>
                    <td>{cand.email}</td>
                    <td>{cand.phone}</td>
                    <td>{new Date(cand.assignedAt).toLocaleString()}</td>
                    <td className={`status-cell ${cand.candidateStatus}`}>
                      {cand.candidateStatus}
                    </td>
                    <td className="action-icons">
  <button
    className="icon-btn"
    title={
      cand.candidateStatus === 'VERIFIED'
        ? 'View Candidate Report'
        : 'Report available only after verification'
    }
    disabled={cand.candidateStatus !== 'VERIFIED'}
    onClick={() =>
      navigate(`/admin/reports/${cand.candidateId}`, {
        state: {
          heading: 'Candidate Report',
          candidate: cand,
        },
      })
    }
  >
    <FilePlus2 size={18} color={cand.candidateStatus === 'VERIFIED' ? 'black' : 'gray'} />
  </button>

  <button
    className="icon-btn"
    title="View Candidate Details"
    onClick={() =>
      navigate(`/admin/candidate-details/${cand.candidateId}`, {
        state: {
          candidate: cand,
        },
      })
    }
  >
    <Eye size={18} />
  </button>
</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  </div>
);

};

export default AssignedCandidates;
